import { directionOf, formatPercent, formatSigned } from '../lib/format'
import styles from './ChangeText.module.css'

export interface ChangeTextProps {
  /** Percent change. `null` renders an em dash (no data). */
  percent: number | null
  /** Optional absolute change shown before the percent, e.g. +5.60 (+0.02%). */
  absolute?: number | null
  decimals?: number
  size?: 'sm' | 'md' | 'lg'
  weight?: 'regular' | 'bold'
  /** On dark (navy) surfaces. */
  onDark?: boolean
}

const WORD = { up: 'up', down: 'down', flat: 'unchanged' } as const
const ARROW = { up: '▲', down: '▼', flat: '■' } as const

/** Price change: arrow + colour + sign, never colour alone. */
export function ChangeText({ percent, absolute, decimals = 2, size = 'md', weight = 'regular', onDark = false }: ChangeTextProps) {
  if (percent === null || Number.isNaN(percent)) {
    return <span className={`${styles.change} ${styles[size]} ${styles.none}`}>—<span className="sr-only"> no data</span></span>
  }
  const dir = directionOf(percent)
  const text = absolute != null
    ? `${formatSigned(absolute, decimals)} (${formatPercent(percent, decimals)})`
    : formatPercent(percent, decimals)
  return (
    <span
      className={[styles.change, styles[size], styles[dir], weight === 'bold' ? styles.bold : '', onDark ? styles.onDark : ''].join(' ')}
      data-direction={dir}
    >
      <span aria-hidden="true" className={styles.arrow}>{ARROW[dir]}</span>
      <span className="sr-only">{WORD[dir]} </span>
      {text}
    </span>
  )
}
